// =============================================================
// FEv1 - Cổng nhân viên (Employee self-service web)
// Module độc lập, KHÔNG dùng chung redux store / auth với app admin.
// Toàn bộ code của cổng nhân viên nằm trong thư mục employeeApp/.
// =============================================================

// Prefix route của toàn bộ cổng nhân viên
export const EMP_BASE_PATH = "/nv";

// Base URL backend (dùng chung env với app admin)
export const EMP_API_BASE_URL =
  process.env.REACT_APP_BACKEND_API || "http://localhost:3001/";

// Khóa lưu trữ localStorage riêng cho nhân viên (tách biệt hẳn với admin)
export const EMP_STORAGE_KEYS = {
  ACCESS_TOKEN: "msh_emp_access_token",
  REFRESH_TOKEN: "msh_emp_refresh_token",
  USER: "msh_emp_user",
};

// Bán kính chấm công mặc định (m) - khớp với CHECK_IN_RADIUS_ENUM của app
export const CHECK_IN_RADIUS_DEFAULT = 200;

// Mã website + tên setting (khớp app mobile) để lấy cấu hình chấm công
export const EMP_WEBSITE_CODE = "mshgroup";
export const EMP_SETTINGS = {
  CHECKIN_RADIUS: "CHECKIN_RADIUS",
  CHECKIN_PLACE_DEFAULT_ID: "CHECKIN_PLACE_DEFAULT_ID",
};

// Loại hình xác thực chấm công (khớp CHECK_IN_TYPE_ENUM của BE)
export const CHECK_IN_TYPE = {
  IMAGE: "IMAGE",
  QRCODE: "QRCODE",
  BSSID: "BSSID",
};

// Trạng thái đơn (dùng chung cho nghỉ phép/ngoài/làm bù)
// Theo BE: 1 = chờ duyệt, 2 = đã duyệt, 3 = từ chối
export const REQUEST_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const REQUEST_STATUS_LABEL = {
  1: "Chờ duyệt",
  2: "Đã duyệt",
  3: "Từ chối",
};

// Một số API trả status dạng chuỗi (registerCheckIn / makeupWorkRequest)
export const REQUEST_STATUS_STRING_LABEL = {
  PENDING: "Chờ duyệt",
  APPROVED: "Đã duyệt",
  REJECTED: "Từ chối",
};
